import { render } from "./ruler.vue?vue&type=template&id=08123eec"
import script from "./ruler.vue?vue&type=script&lang=ts"
export * from "./ruler.vue?vue&type=script&lang=ts"
script.render = render

export default script